(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kehwah-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const sectionsWithin = root => [
      ...(root.matches?.('[data-customer-voices]') ? [root] : []),
      ...root.querySelectorAll('[data-customer-voices]')
    ];
    const init = root => sectionsWithin(root).forEach(section => {
      if (instances.has(section)) return;
      const rail = section.querySelector('[role="list"]');
      if (!rail) return;
      const cards = [...rail.children];
      const controls = section.querySelector('[data-voices-controls]');
      const videos = [...section.querySelectorAll('video')];
      const controller = new AbortController();
      const {signal} = controller;
      let observer;
      let disposed = false;
      videos.forEach(video => video.addEventListener('play', () => {
        document.querySelectorAll('[data-customer-voices] video').forEach(other => { if (other !== video) other.pause(); });
      }, {signal}));
      const previous = controls?.querySelector('[data-voices-prev]');
      const next = controls?.querySelector('[data-voices-next]');
      const position = controls?.querySelector('[data-voices-position]');
      const currentIndex = () => cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - rail.getBoundingClientRect().left) < Math.abs(cards[best].getBoundingClientRect().left - rail.getBoundingClientRect().left) ? index : best, 0);
      const update = () => {
        if (disposed) return;
        if (controls) controls.hidden = cards.length < 2 || rail.scrollWidth <= rail.clientWidth + 2;
        const index = currentIndex();
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index >= cards.length - 1;
        if (position) position.textContent = `${cards.length ? index + 1 : 0} / ${cards.length}`;
        videos.forEach(video => { const card = video.closest('[role="listitem"]'); if (cards.indexOf(card) !== index) video.pause(); });
      };
      const reveal = (card, instant = false) => {
        if (disposed || !cards.includes(card)) return;
        rail.scrollBy({left: card.getBoundingClientRect().left - rail.getBoundingClientRect().left, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        update();
      };
      const move = delta => {
        const index = Math.max(0, Math.min(cards.length - 1, currentIndex() + delta));
        reveal(cards[index]);
      };
      previous?.addEventListener('click', () => move(-1), {signal});
      next?.addEventListener('click', () => move(1), {signal});
      rail.addEventListener('scroll', update, {passive:true, signal});
      if (cards.length) {
        observer = new ResizeObserver(update);
        observer.observe(rail);
      }
      instances.set(section, {
        reveal,
        destroy() {
          disposed = true;
          controller.abort();
          observer?.disconnect();
          videos.forEach(video => video.pause());
          instances.delete(section);
          delete section.dataset.voicesReady;
        }
      });
      section.dataset.voicesReady = 'true';
      update();
    });
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => {
      sectionsWithin(event.target).forEach(section => instances.get(section)?.destroy());
    });
    document.addEventListener('shopify:block:select', event => {
      const card = event.target.closest?.('.editor-testimonial-card');
      const section = card?.closest('[data-customer-voices]');
      if (!section) return;
      init(section);
      instances.get(section)?.reveal(card, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
